import React, { useEffect, useRef, useState } from "react";
// styled components
import {
  notification,
} from "antd";
import {
  FolderOutlined,
  AuditOutlined,
  SearchOutlined,
  CrownOutlined,
  CameraOutlined,
} from "@ant-design/icons";
// hooks
import { usePersonaNatural } from "../../../hooks/usePersonaNatural";
// router
import { useNavigate } from "react-router";
import LogoPerfil from "../../../assets/profile.png";
import apiParticipantes from "../../../api/Participantes/api-participantes";
import { RolesService,} from "../../../api/Roles/api-roles-permisos";
import axios from "axios";
import DocumentosService from "../../../api/Documentos/api-documentos";
import getStorageUser from "../../../middlewares/GetStorageUser"



const rolesService = new RolesService();

interface IProps {
  activeItem: number;
}

export const MenuUsuario: React.FC<IProps> = (props: IProps) => {
  const {
    cargarInformacionParticipante,
    imageSelected,
    setImageSelected,
  } = usePersonaNatural();
  const navigate = useNavigate();
  const showLink: any = false;

  const estadoVistaSubsanacion: any = false;
  const [user, setUser] = useState<any>({});

  const getUser = async () => {
    try {
      const _user = getStorageUser();
      if (_user?.documento) {
        consultarJuradoAceptado(_user.documento);
      }
      setUser(_user);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getUser();
    cargarInformacionParticipante();
    checkAdminPermissions();
  }, []);

  const consultarJuradoAceptado = async (userDocumento: any) => {
    try {
      if (userDocumento) {
        await apiParticipantes.postulacionAceptada(userDocumento);
      }
    } catch (error) {
      console.error("Error en postulacionAceptada:", error);
    }
  };


  const checkAdminPermissions = async () => {
    const token = localStorage.getItem("token");

    if (!token) {
      return navigate("/login");
    }
    const user = getStorageUser();

    if (!user) {
      return navigate("/login");
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_USERS}users/validate/access`,
        { route: "/administrador" },
        {
          headers: {
            Authorization: token,
          },
        }
      );
      return response.data; // Si la respuesta es exitosa, retornamos los datos
    } catch (error: any) {
      if (error.response && error.response.status === 400) {
        const errorMessage = error.response.data?.message;
        if (errorMessage === "Error token invitado invalido (para esta sección)") {
          navigate('/login'); // Redirige a /login si el mensaje coincide
        }
      }
      console.warn("Acceso admin no autorizado o error de validación:", error?.message || error);
    }
  };

  /**
   * Las clases de cada entrada del menu, resaltada si es la activa.
   *
   * Antes esto se resolvia buscando los botones en el DOM por su clase y
   * entrando por posicion, asi que quitar una entrada corria las demas y la
   * pantalla que pedia la ultima se caia. Si el indice no corresponde a
   * ninguna entrada, simplemente no se resalta ninguna.
   */
  const clasesDelItem = (indice: number, extra = "") =>
    `${extra}menu-nav-item-btn font-family-Montserrat-SemiBold font-size-14px container-padding-link-usuario-logeado${
      props.activeItem === indice ? " active-buscar-convocatoria" : ""
    }`;

  const fileImageRef = useRef<any>();
  const openNotification = ({ titulo, descripcion, placement }: any) => {
    notification.info({
      message: titulo,
      description: descripcion,
      placement,
    });
  };
  const guardarFoto = async (e: any) => {
    if (e.target.files.length > 0) {
      if (e.target.files[0].size > 5000000) {
        return openNotification({
          titulo: "Error",
          descripcion: "Solo se permiten archivos menores a 5MB",
          placement: "bottomRight",
        });
      }
      if (
        e.target.files[0].type === "image/jpeg" ||
        e.target.files[0].type === "image/png"
      ) {
        const { name } = e.target.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onloadend = () => {
          setImageSelected(URL.createObjectURL(e.target.files[0]));
        };
        const formData = new FormData();
        formData.append("archivo", e.target.files[0]);
        let payload = {
          path_foto: name,
        };
        await apiParticipantes.guardarFoto(payload, 1000000002);
        await DocumentosService.guardarArchivo(formData);
        return openNotification({
          titulo: "Imagen Actualizada",
          placement: "bottomRight",
        });
      } else {
        return openNotification({
          titulo: "Error",
          descripcion: "Solo se permiten archivos PNG o JPG",
          placement: "bottomRight",
        });
      }
    }
  };
  return (
    <div className="col-12 col-md-4 col-lg-2 menu-usuario-col">
      <div className="menu-usuario-sidebar row-shadow2">
        {/* Cabecera del perfil de usuario */}
        <div className="menu-usuario-profile-section">
          <div
            className="menu-avatar-wrapper"
            onClick={() => fileImageRef.current?.click()}
            title="Cambiar imagen de perfil"
            role="button"
            tabIndex={0}
          >
            <img
              src={imageSelected !== "" ? imageSelected : LogoPerfil}
              alt="imagen-perfil"
              className="menu-avatar-img"
            />
            <div className="menu-avatar-badge" title="Subir foto">
              <CameraOutlined />
            </div>
          </div>

          <input
            ref={fileImageRef}
            type="file"
            hidden
            accept="image/png, image/jpeg"
            onChange={(e) => {
              guardarFoto(e);
              e.target.value = "";
            }}
          />

          <div className="menu-greeting-label">Hola,</div>
          <div className="menu-user-fullname">
            {`${user.nombres || ""} ${user.apellidos || ""}`.trim() || "Usuario"}
          </div>
          <div className="menu-user-tag">Participante</div>
        </div>

        <div className="menu-divider" />

        <nav className="menu-nav-list" aria-label="Navegación principal de usuario">
          <button
            type="button"
            className={clasesDelItem(0)}
            onClick={() => navigate("/usuario/Mispostulaciones")}
            style={{ cursor: "pointer", background: 'none', border: 'none', width: '100%', textAlign: 'left' }}
          >
            <FolderOutlined className="menu-nav-icon" />
            <span className="menu-nav-text">Mis Proyectos</span>
            {estadoVistaSubsanacion ? <span className="menu-nav-alert-icon">🔔</span> : null}
          </button>

          <button
            type="button"
            className={clasesDelItem(1)}
            onClick={() => navigate("/usuario/MenuJurado")}
            style={{ cursor: "pointer", background: 'none', border: 'none', width: '100%', textAlign: 'left' }}
          >
            <AuditOutlined className="menu-nav-icon" />
            <span className="menu-nav-text">Jurado</span>
          </button>

          <button
            type="button"
            className={clasesDelItem(2)}
            onClick={() => navigate("/usuario/")}
            style={{ cursor: "pointer", background: 'none', border: 'none', width: '100%', textAlign: 'left' }}
          >
            <SearchOutlined className="menu-nav-icon" />
            <span className="menu-nav-text">Buscar convocatoria</span>
          </button>

          {showLink && (
            <button
              type="button"
              className={clasesDelItem(3, "col-12 ")}
              onClick={() => navigate("/administrador")}
              style={{ cursor: "pointer", background: 'none', border: 'none', width: '100%', textAlign: 'left' }}
            >
              <CrownOutlined className="menu-nav-icon" />
              <span className="menu-nav-text">Administrador</span>
            </button>
          )}
        </nav>
      </div>
    </div>
  );
};

